module.exports = __webpack_public_path__ + "static/media/NoItemsCartImage.435e64b5.png";